import { keepPreviousData, QueryKey, queryOptions, useQuery, UseQueryOptions } from '@tanstack/react-query';

/** How long a selection dialog serves its list from the cache before it reads the list again. */
export const DIALOG_LIST_STALE_TIME = 5 * 60 * 1000;

/**
 * The query of a selection dialog list. A dialog builds both its prefetch and its own query from the same options,
 * so the prefetched list is the one the dialog opens with.
 */
export const dialogListQueryOptions = <T>(queryKey: QueryKey, queryFn: () => Promise<T[]>) =>
  queryOptions({ queryKey, queryFn, staleTime: DIALOG_LIST_STALE_TIME });

/**
 * Loads the list of a selection dialog while the dialog is open. Opening it shows the cached list - prefetched or
 * from an earlier opening - and reads it again only when it is older than {@link DIALOG_LIST_STALE_TIME} or failed to
 * load. While another filter loads, the previous list stays on screen.
 */
const useDialogListQuery = <T>(options: UseQueryOptions<T[], Error, T[], QueryKey>, isOpened: boolean) =>
  useQuery({ ...options, enabled: isOpened, placeholderData: keepPreviousData });

export default useDialogListQuery;
